'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {

  return (
    <html lang="zh-CN">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: '16px',
            padding: '24px',
          }}
        >
          <h2 style={{ fontSize: '18px', fontWeight: 600 }}>
            应用发生错误
          </h2>
          <p style={{ fontSize: '14px', color: '#666' }}>
            {error.digest
              ? `错误代码：${error.digest}`
              : '请刷新页面重试'}
          </p>
          <button
            onClick={() => reset()}
            style={{
              padding: '8px 24px',
              fontSize: '14px',
              borderRadius: '6px',
              border: '1px solid #ddd',
              cursor: 'pointer',
              background: '#fff',
            }}
          >
            重试
          </button>
        </div>
      </body>
    </html>
  );
}
